import NotificationsList from "shared/components/dashboardCommon/notificationsList";

const ClientNotifications = () => {
  return (
    <NotificationsList
      pageHeadingSize="large"
      customHeadingWrapperClassName="sm:pr-0 pr-12"
    />
  );
};

export default ClientNotifications;
